module.exports = __webpack_public_path__ + "static/media/zoom.7557c851.svg";